// extracted by mini-css-extract-plugin
export default {"avatar":"xTXW_oh","info":"BqSFZnr","title":"MjVjGNk","subtitle":"gLRPsCi","actingAs":"cN9ZWVm"};